// extracted by mini-css-extract-plugin
module.exports = {"label":"styles__label___21Wx8","labelOff":"styles__labelOff___8z12A styles__label___21Wx8","container":"styles__container___2Ufsi","value":"styles__value___y9u0R"};